export default {
  startshopping: {
    subtitle: "للمطاعم",

    title1: "ابدأ الطلب في",
    title2: "3 خطوات بسيطة",

    desc:
      "ابدأ مع MAHAL بسرعة وقم بإدارة عمليات التوريد لمطعمك بسهولة.",

    step1: {
      title: "أنشئ حسابك",
      desc: "قم بتسجيل مطعمك وإعداد تفاصيل التوصيل في دقائق.",
      btn: "إنشاء حساب →",
    },

    step2: {
      title: "استكشف السوق",
      desc: "تصفح الموردين الموثوقين وقارن الأسعار وأضف المنتجات إلى سلتك.",
      btn: "استكشاف السوق →",
    },

    step3: {
      title: "اطلب وتتبع الطلبات",
      desc: "قم بتأكيد التوصيل وتتبع طلباتك حتى تصل إلى مطبخك.",
      btn: "تتبع الطلبات →",
    },
  },
};